__webpack_require__.p = "/dst-uat-bahrain/";